<template>
  <div class="money-table-content" :class="`money-table-content-${type}`">
    <div v-for="(item, index) in data" :key="index" class="table-content-block">
      <label class="table-content__label" :style="`width: ${item.labelWidth}px`">{{item.label}}<span v-if="type !== 'popover'">:</span></label>
      <table class="table-content__table">
        <tr class="table-content__tr">
          <th
            class="table-content__th"
            v-for="(itemTh, indexTh) in item.col"
            :width="itemTh.width"
            :height="itemTh.height"
            :key="indexTh"
          >{{itemTh.title}}</th>
        </tr>
        <tr
          class="table-content__tr"
          v-for="(itemTd, indexTd) in item.data"
          :key="indexTd"
        >
          <!-- 会员类型/流量类型 -->
          <td class="table-content__td" >
            {{itemTd.type}}
            <span class="table-content__sectionMonty" v-if="type !== 'popover'">({{itemTd.min}}-{{itemTd.max}})</span>
          </td>
          <!-- 标准费用 -->
          <td class="table-content__td" >{{itemTd.money | toFix}}</td>
          <!-- 优惠后费用 -->
          <td class="table-content__td" >
            <Input
              v-if="type !== 'popover'"
              class="table-content__input"
              v-model.trim="itemTd.val"
              placeholder="0.00"
              :title="itemTd.val"
              @keyup.native="itemTd.val=itemTd.val.replace(/[^\d^\.]+/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
              @on-blur="changeVal(itemTd, index, indexTd)"
            />
            <span v-else>{{itemTd.val}}</span>
            <em v-if="itemTd.showTips" class="table-tips">请输入区间值</em>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
// value=value.replace(/[^\d^\.]+/g,'') 数字加小数点
// itemTd.val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '') 只能输入数字
// import pageTable from '@/components/pageCom/pageTable.vue'
export default {
  components: {
    // pageTable
  },
  data() {
    return {}
  },
  props: {
    data: Array,
    type: {
      type: String,
      default: 'none'
    }
  },
  filters: {
    toFix(val) {
      if (val === undefined || val === null) {
        return ''
      } else {
        return Number(val).toFixed(2)
      }
    }
  },
  methods: {
    changeVal(item, index, indexChildren) {
      // item.val = Number(item.val).toFixed(2)
      // item.val = item.val === '' ? '' : Number(item.val).toFixed(2)
      if (item.val < item.min || item.val > item.max) {
        this.$emit('changeValTips', index, indexChildren, true)
      } else {
        this.$emit('changeValTips', index, indexChildren, false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.table-content-block {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}
.table-content__label {
  margin-right: 10px;
  line-height: 28px;
  text-align: right;
}
.table-content__table {
  border-spacing: 0;
  border: solid 1px #DAE3EA;
}
.table-content__th {
  background: #F3F6F8;
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  font-weight: 500;
  color: #5D6F80;
  padding: 0 8px;
  text-align: left;
  border-bottom: solid 1px #DAE3EA;
}
.table-content__tr {
  border-bottom: solid 1px #DAE3EA;
  &:last-child > td {
    border: none;
  }
}
.table-content__td {
  height: 44px;
  line-height: 44px;
  border-bottom: solid 1px #DAE3EA;
  padding: 0 8px;
  font-size: 12px;
  color: #5D6F80;
}
.table-content__sectionMonty {
  font-size: 12px;
  color: #B5C2D0;
  margin-left: 4px;
}
.table-content__input {
  width: 80px;
  margin-top: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  & /deep/.ivu-input {
    border-radius: 2px;
  }
}
.table-tips {
  font-size: 12px;
  color: $tipsColor;
  // letter-spacing: 0.6px;
  line-height: 44px;
  font-style: normal;
  margin-left: 9px;
  transition: all .2s;
}
// 浮窗时的样式
.money-table-content-popover {
  .table-content__th,
  .table-content__td {
    height: 30px;
    line-height: 30px;
    padding: 0 8px !important;
  }
  .table-content-block {
    display: block;
    padding: 12px 4px 8px 4px;
    margin-top: 0;
  }
  .table-content__label {
    display: block;
    line-height: 12px;
    margin: 0 0 10px 0;
    text-align: left;
  }
  .table-content-block {
    &:last-child {
      padding-bottom: 12px;
    }
  }
}
// 编辑状态样式
.money-table-content-edit {
  .table-content__label {
    padding-right: 10px;
    margin: 0;
  }
}
</style>
